function initialState() {
  return { orderOutOfStock: null };
}

export function orderOutOfStock(state = initialState(), action) {
  switch (action.type) {
    case 'SET_ORDER_OUT_OF_STOCK':
      return { ...state, orderOutOfStock: action.orderOutOfStock };
    default:
      return state;
  }
}
